module.exports = __webpack_public_path__ + "static/media/logout.38ee1189.svg";